<template>
    <router-link
        :to="{ name: 'movie', params: { id: movie.id } }"
        class="card_wrapper"
        v-if="!loader"
    >
        <!-- DEFAULT state -->
        <movie-card-label :item="item" />

        <div class="card">
            <div
                draggable="false"
                class="serial_tag hide_serial_tag"
                v-if="+movie.is_season"
            >
                <img src="../../assets/icons/serialCart.svg" alt="serialCart" />
            </div>
            <img
                draggable="false"
                class="img_hover_state"
                src="../../assets/assets/noImageAvailable.webp"
                :alt="movie.name"
                loading="lazy"
                v-if="!isImgLoaded"
                ref="cardImg"
            />
            <img
                v-else
                draggable="false"
                class="img_hover_state"
                loading="lazy"
                :src="setImg()"
                :alt="item.name"
                ref="cardImg"
            />

            <h3 class="movie_name" v-show="$route.name !== 'home'">
                {{ item.name }}
            </h3>

            <span class="gradient_block" v-show="$route.name !== 'home'"></span>
        </div>
        <!-- --//-- DEFAULT state -->

        <!-- HOVER state -->
        <div class="hover_state">
            <div class="age_rating" v-if="movie.ageRating != -1">
                {{ movie.ageRating }}+
            </div>

            <h3
                class="movie_name_hover_state"
                :class="{ marquee: movie.name.length > 40 }"
            >
                <span>{{ item.name }}</span>
            </h3>

            <ul class="about_movie">
                <li
                    v-for="(movieItem, i) in movie.aboutMovie"
                    :key="i"
                    class="about_movie_item"
                >
                    {{ movieItem.about }}
                </li>
            </ul>

            <div
                class="movie_ratings"
                v-if="movie.movieRating.kinopoisk !== movie.movieRating.imdb"
            >
                <div
                    class="movie_rating_item"
                    v-if="movie.movieRating.kinopoisk"
                >
                    <img
                        src="../../assets/assets/Kinopoisk.svg"
                        alt="Kinopoisk"
                    />
                    <span>{{ movie.movieRating.kinopoisk }}</span>
                </div>
                <div class="movie_rating_item" v-if="movie.movieRating.imdb">
                    <img src="../../assets/assets/IMDB.svg" alt="IMDB" />
                    <span>{{ movie.movieRating.imdb }}</span>
                </div>
            </div>

            <div class="movie_ratings" v-else-if="movie.movieRating.kinopoisk">
                <div class="movie_rating_item">
                    <img
                        src="../../assets/assets/Kinopoisk.svg"
                        alt="Kinopoisk"
                    />
                    <span>{{ movie.movieRating.kinopoisk }}</span>
                </div>
            </div>
        </div>
        <!-- --//-- HOVER state -->
    </router-link>
    <div class="card__wrapper skeleton" v-else>
        <div class="card">
            <div class="card__img"></div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import noImageAvailable from "../../assets/assets/noImageAvailable.webp";
import MovieCardLabel from "./MovieCardLabel.vue";
import { WORD_NOT_VISIBLE_DETAIL_PAGE } from "../constants/movie_constants";

export default {
    name: "NewMovieCard",

    components: {
        MovieCardLabel,
    },

    props: {
        item: {
            type: Object,
        },

        extra: {
            type: Object,
        },
        loader: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        providerImg: "",
        isFree: false,
        isPremier: false,
        isExclusive: false,
        isDisney: false,
        isDorama: false,
        isUzb: false,
        hasNewEpisode: false,
        noImageAvailable: noImageAvailable,
        isImgLoaded: false,
        imgSrc: noImageAvailable,
    }),

    created() {
        this.cardImage();
    },

    computed: {
        ...mapGetters(["checkAccess"]),

        movie() {
            if (!this.item) return;
            const item = this.item;
            const formattedMovie = {};

            formattedMovie.movieRating = {
                kinopoisk: this.ratingFormatter(item?.kinopoisk_rating),
                imdb: this.ratingFormatter(item?.imdb_rating),
            };

            formattedMovie.name = item.name;
            formattedMovie.ageRating = item.rating;
            formattedMovie.aboutMovie = this.getAboutMovie(item);

            return {
                ...item,
                ...formattedMovie,
            };
        },
    },

    methods: {
        cardImage() {
            if (!this.item) return;

            if (!this.item.thumbnail_big) return (this.isImgLoaded = false);
            this.isImgLoaded = true;
            const img = new Image();
            img.src = `${this.setImg()}`;

            new Promise((resolve) => {
                // img.onload = () => {
                //     this.isImgLoaded = true;
                //     resolve();
                // };
                img.onerror = () => {
                    this.isImgLoaded = false;
                    resolve();
                };
            });
        },
        setImg() {
            if (!this.item) return;

            if (window.innerWidth >= 768) {
                return this.item.thumbnail_big;
            } else {
                if (this.item.thumbnail_small) {
                    return this.item.thumbnail_small;
                } else {
                    return this.item.thumbnail_big;
                }
            }
        },

        filterMovieName(name) {
            const firstLetterToUppercase =
                name.slice(0, 1).toUpperCase() + name.slice(1);

            return firstLetterToUppercase
                .match(/[+0-9а-яёА-Яa-zA-Z0-9-\s\d\.,:—!?'"]*/gi)[0]
                .trimEnd();
        },

        getAboutMovie(movie) {
            if (!this.item) return;

            const result = [];

            const setAboutMovie = (movieItem) =>
                movieItem && result.push({ about: movieItem });

            setAboutMovie(this.timeConverter(movie.duration));
            setAboutMovie(movie.year);
            setAboutMovie(this.filterMovieCountries(movie.countries));
            setAboutMovie(this.janresFormatter(movie.genres));

            return result;
        },

        filterMovieCountries(item) {
            if (!this.item) return;

            const itemsArr = item.split(", ");
            return itemsArr.slice(0, 2).join(", ");
        },

        timeConverter(n) {
            if (!this.item) return;

            if (!n) return 0;

            let num = n;
            let hours = num / 60;
            let rhours = Math.floor(hours);
            let minutes = (hours - rhours) * 60;
            let rminutes = Math.round(minutes);

            const h = rhours ? rhours + "ч. " : "";
            const m = rminutes ? rminutes + "мин." : "";

            const duration = h + m;

            return duration;
        },

        janresFormatter(janres) {
            if (!this.item) return;

            if (!janres.length) return "";

            const janresArr = janres.split(", ");
            const filteredJanresArr = janresArr.filter(
                (janr) => !WORD_NOT_VISIBLE_DETAIL_PAGE.includes(janr)
            );
            const firstTwoJanres = filteredJanresArr.slice(0, 2).join(", ");
            return firstTwoJanres;
        },

        ratingFormatter(rating) {
            if (!this.item) return;

            if (!+Number(rating).toFixed(1)) return 0;
            return Number(rating).toFixed(1);
        },
    },
};
</script>
<!-- default state -->
<style scoped lang="scss">
.router_link:hover ~ .card {
    transform: scale(1.07);
}

.card_wrapper {
    position: relative;
    cursor: pointer;
    transition: 0.2s;
    pointer-events: none;
    width: 100%;
    height: 100%;
    display: block;
    user-select: none;
}

.card {
    position: relative;
    overflow: hidden;
    height: 100%;
    pointer-events: fill;
    display: flex;
    transition: scale 0.2s;
    padding-bottom: 143%;
    // will-change: scale;
    background: url("../../assets/assets/noImageAvailable.webp") no-repeat
        center center / cover;
}
@mixin loader {
    background: linear-gradient(100deg, #3f3f3f 30%, #e41a4b 50%, #3f3f3f 70%);
    background-size: 500%;
    animation: loading 1s ease-in-out infinite;
}
@keyframes loading {
    0% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0 50%;
    }
}

.card {
    &__img {
        position: absolute;
        width: 100%;
        height: 100%;
        @include loader;
    }
}

.gradient_block {
    position: absolute;
    bottom: -10%;
    left: -10%;
    width: 150%;
    height: 12rem;
    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(0, 0, 0, 0.5) 50%,
        rgba(0, 0, 0, 0.8) 80%,
        rgba(0, 0, 0, 0.9) 100%
    );
}

.card > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
}

.serial_tag {
    position: absolute;
    top: -2px;
    right: -2px;
    z-index: 2;
}

.serial_tag > img {
    width: 70px;
}

.grid_row_pos_2 {
    grid-row-start: 2;
}

.riza_nova {
    padding: 7px 13px;
    background: #313131;
    font-size: 16px;
    text-align: center;
}

.riza_nova > span:first-child {
    font-weight: 600;
}

.movie_name {
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
    padding: 0 15px;
    color: #f5f5f5;
    font-size: 18px;
    font-weight: 600;
    text-wrap: balance;
    text-align: center;
    text-shadow: 0px 0px 10px #00000085;
    z-index: 1;
}
</style>
<!-- --//-- default state -->

<!-- hover state -->
<style scoped lang="scss">
.hover_state {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    // background: #19191937;
    height: 100%;
    width: 100%;
    opacity: 0;
    // will-change: opacity;
    transition: opacity 0.3s;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding: 20px;
    gap: 15px;
    overflow: hidden;
}

.card:hover {
    transform: scale(1.07);
}

.card_wrapper:hover {
    // transform: scale(1.07);
    z-index: 3;

    .hover_state {
        opacity: 1;
    }

    .img_hover_state {
        filter: blur(8.5px) brightness(0.5);
        transform: scale(1.1);
    }

    .labels_top_list_left,
    .labels_list_right,
    .labels_list_left,
    .movie_name {
        opacity: 0;
    }
}

.img_hover_state {
    transition: 0.3s;
}

.age_rating {
    padding: 4px 6px;
    background: #ffffffc2;
    font-size: 15px;
    color: #1c1c1c;
    font-weight: 600;
    border-radius: 3px;
}

.movie_name_hover_state {
    flex: 1;
    font-size: 18px;
    font-weight: 600;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    color: #e3e3e3;
    display: -webkit-box;
    line-height: 22px;
    overflow: hidden;
    white-space: pre-wrap;
}

.about_movie {
    list-style-type: none;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;
}

.about_movie_item {
    font-size: 16px;
    font-weight: 500;
    color: #e3e3e3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
}

.movie_ratings {
    display: flex;
    flex: 1;
    justify-content: center;
    width: 100%;
    gap: 20px;
}

.movie_rating_item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.movie_rating_item > img {
    width: 35px;
}

.movie_rating_item > span {
    font-size: 24px;
    font-weight: 500;
}

/* animations (marque) */
.marquee {
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
}

.marquee span {
    display: inline-block;
    padding-left: 100%;
    -webkit-animation: scroll 10s infinite linear;
    -moz-animation: scroll 10s infinite linear;
    animation: scroll 6s infinite linear;
}

@-webkit-keyframes scroll {
    0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
    }
    100% {
        -webkit-transform: translate(-100%, 0);
        transform: translate(-100%, 0);
    }
}

@-moz-keyframes scroll {
    0% {
        -moz-transform: translate(0, 0);
        transform: translate(0, 0);
    }
    100% {
        -moz-transform: translate(-100%, 0);
        transform: translate(-100%, 0);
    }
}

@keyframes scroll {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(-100%, 0);
    }
}
/* --//-- animations (marque) */
</style>

<style lang="scss">
.card_wrapper:hover {
    .labels_top_list_left,
    .labels_list_right {
        opacity: 0;
    }
}
@media screen and (max-width: 700px) {
    .card_wrapper:hover {
        .labels_top_list_left,
        .labels_list_right,
        .labels_list_left {
            opacity: 1;
        }
    }
}
</style>
<!-- --//-- hover state -->

<style scoped lang="scss">
@media screen and (max-width: 700px) {
    .collection_title {
        font-size: 22px;
    }

    .movie_name {
        font-size: 16px;
    }

    .serial_tag > img {
        width: 70px;
    }
    .card:hover {
        transform: scale(1);
    }

    .card_wrapper:hover {
        opacity: 1;
        transform: none;

        .hover_state {
            opacity: 0;
        }

        .img_hover_state {
            filter: none;
            transform: none;
        }

        .labels_top_list_left,
        .labels_list_right,
        .labels_list_left,
        .movie_name {
            opacity: 1;
        }
    }

    .serial_tag > img {
        width: 65px;
    }

    .riza_nova {
        padding: 5px 10px;
        background: #313131;
        font-size: 13px;
    }

    .movie_name {
        font-size: 15px;
        bottom: 15px;
        padding: 5px;
    }

    .router_link:hover ~ .card {
        transform: none;
    }
}

@media screen and (min-width: 1660px) {
    .serial_tag > img {
        width: 85px;
    }
}
</style>
